import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GenericModal from './GenericModal';
import i18n from '../../src/i18n/translate';
import Icon from './Icon';
import { onExecuteKeyDown, onVerticalArrowNavigation } from '../util/KeyboardUtil';

export default class LanguageModal extends Component {
  static propTypes = {
    enforceSelection: PropTypes.bool,
    languages: PropTypes.object,
    onConfirmSelection: PropTypes.func,
    selectedLanguage: PropTypes.string,
    showLanguageModal: PropTypes.bool,
    title: PropTypes.string,
    toggleLanguageModal: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedLanguage: props.selectedLanguage
    };
  }

  componentDidMount = () => {
    if (i18n) {
      i18n.loadTranslations();
    }
  }

  onConfirmSelection = () => {
    const { toggleLanguageModal, languages, onConfirmSelection } = this.props;
    const { selectedLanguage } = this.state;

    if (onConfirmSelection) {
      onConfirmSelection(selectedLanguage);
    }

    toggleLanguageModal();

    if (languages?.[selectedLanguage]?.translation_url) {
      window.location.href = languages[selectedLanguage].translation_url;
    }
  }

  onClose = () => {
    const { toggleLanguageModal, selectedLanguage } = this.props;
    this.setState({ selectedLanguage });
    toggleLanguageModal();
  }

  languageElements = () => Array.from(this.container.childNodes);

  get title() {
    return (
      <span className="h2">
        <Icon iconType="translate" additionalClasses="m-r-10" />
        {this.props.title || i18n.t("Choose Your Language")}
      </span>
    );
  }

  render() {
    const {
      languages,
      showLanguageModal,
      selectedLanguage: propSelectedLanguage,
      enforceSelection
    } = this.props;
    if (!languages) return null;
    if (typeof languages !== "object" || Object.keys(languages).length <= 0) return null;
    const { selectedLanguage } = this.state;
    const confirmButtonDisabled = !enforceSelection && selectedLanguage === propSelectedLanguage;
    const footerCloseButton = { isTurnedOn: true, text: i18n.t('Cancel'), bsStyle: 'secondary btn-secondary-branded' };
    const saveButtonConfig = {
      disabled: confirmButtonDisabled,
      saveText: i18n.t('Save'),
      saveStyle: 'primary btn-primary-branded',
      saveAction: this.onConfirmSelection
    };

    return (
      <GenericModal
        canClose={!enforceSelection}
        footerCloseButton={!enforceSelection && footerCloseButton}
        modalClass="languages-modal"
        modalSize="medium"
        onClose={this.onClose}
        saveButtonConfig={saveButtonConfig}
        show={showLanguageModal}
        title={this.title}
      >
        <div
          ref={(container) => { this.container = container; }}
          className="language-picker-area"
          role="menu"
          aria-label={i18n.t('select a language')}
          tabIndex={0}
          onKeyDown={onVerticalArrowNavigation(this.languageElements)}>
          {Object.entries(languages).map(([code, { native_name }]) => {
            const isSelected = selectedLanguage === code;
            return (
              <div
                aria-pressed={isSelected}
                className={`language-option ${isSelected ? 'is-selected' : ''}`}
                key={code}
                lang={code}
                onClick={() => this.setState({ selectedLanguage: code })}
                onKeyDown={onExecuteKeyDown(() => this.setState({ selectedLanguage: code }))}
                role="button"
                tabIndex={-1}
                data-object-type="languages"
                data-object-id={code}
                data-selected={isSelected}
              >
                {native_name}
              </div>
            );
          })}
        </div>
      </GenericModal>
    );
  }
}
